const ANDROID = 'Android';

export const isAndroid = (userAgent: string = navigator.userAgent) => userAgent.includes(ANDROID);
